import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withMobileDialog,
  Dialog,
  withStyles,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import DateTimePicker from 'components/AddOrEditTaskPage/DateTimePicker'
import { handleCalendarChange, addTaskFromDialog } from 'actions/tasks'

export function fiveMinutesFromNow() {
  let date = new Date()
  date.setMinutes(date.getMinutes() + 5)
  return date
}

function getTomorrowAt10am() {
  let date = new Date() // Get the current date
  date.setDate(date.getDate() + 1) // Add a day to get tomorrow's date
  date.setHours(10, 0, 0, 0) // Set time to 10am and clear minutes, seconds, and milliseconds
  return date
}

function getOneWeekFromNowAt10am() {
  let date = new Date() // Get the current date
  date.setDate(date.getDate() + 7) // Add 7 days to get a week from the current date
  date.setHours(10, 0, 0, 0) // Set time to 10am and clear minutes, seconds, and milliseconds
  return date
}

function timeUntilFutureDate(inputDate) {
  const now = new Date()
  const date = new Date(inputDate)

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  if (date < now) {
    return 'Date is in the past'
  }

  const seconds = Math.ceil((date - now) / 1000)
  const minutes = Math.ceil(seconds / 60)
  const hours = Math.ceil(minutes / 60)
  const days = Math.ceil(hours / 24)
  const weeks = Math.ceil(days / 7)
  const months = Math.ceil(days / 30.44) // Average number of days in a month
  const years = Math.ceil(days / 365.25) // Average number of days in a year considering leap years

  if (seconds < 60) {
    return 'in a few seconds'
  } else if (minutes === 1) {
    return 'in one minute'
  } else if (minutes < 60) {
    return 'in ' + minutes + ' minutes'
  } else if (hours === 1) {
    return 'in one hour'
  } else if (hours < 24) {
    return 'in ' + hours + ' hours'
  } else if (days === 1) {
    return 'in one day'
  } else if (days < 7) {
    return 'in ' + days + ' days'
  } else if (weeks === 1) {
    return 'in one week'
  } else if (weeks < 5) {
    return 'in ' + weeks + ' weeks'
  } else if (months === 1) {
    return 'in one month'
  } else if (months < 12) {
    return 'in ' + months + ' months'
  } else if (years === 1) {
    return 'in one year'
  } else {
    return 'in ' + years + ' years'
  }
}

const Scheduling = ({ handleCalendarChange, dateValue }) => (
  <div style={{ padding: 12, minHeight: 315 }}>
    <DateTimePicker modal />
    <div style={{ marginTop: -5, marginBottom: 5 }}>
      {timeUntilFutureDate(dateValue)}
    </div>
    <div style={{ textAlign: 'right' }}>
      <Button
        style={{ marginRight: 5 }}
        onClick={() => {
          handleCalendarChange(fiveMinutesFromNow())
        }}
        color="secondary"
        variant="contained"
      >
        In 5 minutes
      </Button>
      <Button
        style={{ marginRight: 5 }}
        onClick={() => {
          handleCalendarChange(getTomorrowAt10am())
        }}
        color="secondary"
        variant="contained"
      >
        Tomorrow
      </Button>
      <Button
        onClick={() => {
          handleCalendarChange(getOneWeekFromNowAt10am())
        }}
        color="secondary"
        variant="contained"
      >
        In one week
      </Button>
    </div>
  </div>
)

export default connect(
  (state, { disabledState }) => {
    const disabled = disabledState ? disabledState(state) : undefined
    return {
      dialogOpen: state.view.dialogs?.scheduling?.open,
      date: state.tasks.addOrEdit.fields.date.value,
      disabled,
      messageType: state.inbox.to?.current?.type,
      dateValue: state.tasks.addOrEdit.fields.date.value,
    }
  },
  dispatch =>
    bindActionCreators(
      { toggleDialog, handleCalendarChange, addTaskFromDialog },
      dispatch,
    ),
)(
  withMobileDialog()(
    withStyles(theme => ({
      rounded: {
        borderRadius: 28,
        // overflowY: 'hidden',
        // [theme.breakpoints.down('sm')]: {
        //   borderRadius: 0,
        //   overflowY: 'auto',
        // },
      },
      dialogContentRootTemplate: {
        padding: 0,
        '&:first-child': {
          paddingTop: 0,
        },
        [theme.breakpoints.up('md')]: {
          minHeight: 525,
        },
      },
      dialogContentRoot: {
        padding: 0,
        '&:first-child': {
          paddingTop: 0,
        },
      },
    }))(
      ({
        fullScreen,
        dialogOpen,
        classes,
        toggleDialog,
        date,
        handleCalendarChange,
        addTaskFromDialog,
        clearText,
        messageType,
        children,
        closeFn,
        disabled,
        dialogType,
        dateValue,
      }) => (
        <Dialog
          fullWidth
          maxWidth="sm"
          fullScreen={fullScreen}
          open={Boolean(dialogOpen)}
          onClose={() =>
            toggleDialog({ dialog: 'scheduling', open: false, options: {} })
          }
          aria-labelledby="responsive-dialog-title"
          PaperProps={{ classes: { rounded: classes.rounded } }}
        >
          <DialogContent
            classes={{
              root:
                dialogType === 'template'
                  ? classes.dialogContentRootTemplate
                  : classes.dialogContentRoot,
            }}
          >
            {children}
            <div style={{ marginLeft: 10, marginTop: 10 }}>
              <Typography variant="h6" gutterbottom>
                {/* This shouldn't be messageType if it's a template: */}
                Schedule this {/* messageType || */ 'message'} to send later
              </Typography>
            </div>
            <Scheduling
              dateValue={dateValue}
              handleCalendarChange={handleCalendarChange}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleCalendarChange(null)
                if (closeFn) {
                  closeFn()
                }
                toggleDialog({ dialog: 'scheduling', open: false })
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              disabled={
                typeof disabled === 'boolean'
                  ? disabled || !date || date < new Date()
                  : !date || date < new Date()
              }
              onClick={() => {
                Promise.resolve(
                  // messageType should be separate from dialogType
                  addTaskFromDialog({ dialogType }),
                ).then(() => {
                  toggleDialog({
                    dialog: 'scheduling',
                    open: false,
                    options: {},
                  })
                  if (closeFn) {
                    closeFn()
                  }
                  if (clearText) {
                    clearText()
                  }
                  handleCalendarChange(null)
                })
              }}
              color="primary"
            >
              Schedule message
            </Button>
          </DialogActions>
        </Dialog>
      ),
    ),
  ),
)
